import {german_states_translation} from "./global";

function getStateTranslation(state){ // todo country
    return german_states_translation[state];

}
export default getStateTranslation;